module.exports = __webpack_public_path__ + "static/media/paint.f8f7de91.svg";